<div class="container">
    <img [src]="url$ | async" [className]="size">
</div>
